import {captureError} from '../../../utils/log';
import {startError, startLoading} from '../../../utils/reducer';

export default (state, action) => {
  switch (action.type) {
    case 'UPDATE_DOSSIER_COUNTRY':
      return {
        ...state,
        dossierCountry: action.dossierCountry
      };
    case 'UPDATE_SUBCONTRACTOR':
      return {
        ...state,
        subcontractor: {
          details: action.subcontractor,
          loading: false
        }
      };
    case 'UPDATE_DOCUMENTS':
      return {
        ...state,
        documents: {
          list: action.documents,
          loading: false
        }
      };
    case 'UPDATE_ARCHIVES':
      return {
        ...state,
        archives: {
          list: action.archives,
          loading: false
        }
      };
    case 'UPDATE_INTERVENTIONS':
      return {
        ...state,
        interventions: {
          ...state.interventions,
          list: action.interventions,
          totalCount: action.totalCount,
          loading: false
        }
      };
    case 'UPDATE_USERS':
      return {
        ...state,
        users: {
          ...state.users,
          list: action.users,
          totalCount: action.totalCount,
          loading: false
        }
      };
    case 'UPDATE_REMINDERS':
      return {
        ...state,
        reminders: {
          ...state.reminders,
          list: action.reminders,
          totalCount: action.totalCount,
          loading: false
        }
      };
    case 'START_LOADING_ALL':
      return startLoading(state, Object.keys(state).filter(key => key !== 'dossierCountry'));
    case 'START_LOADING':
      return startLoading(state, action.keys);
    case 'ERROR':
      return startError(state, action.key);
    default:
      captureError('Invalid action type on subcontractor details reducer');
  }

  return false;
};
